import React, { useState, useRef } from "react";
import clsx from "clsx";
import {
	Container,
	Button,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	CustomInput,
} from "reactstrap";
import { sendCOVIDAnswer } from "../../api";
import { Link } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
const CovidAnswer = (props) => {
	const [form, setForm] = useState({});
	const [status, setStatus] = useState({
		isLoading: false,
		isSuccess: false,
		isError: false,
	});

	function handleChange(event) {
		const target = event.target;
		const value = target.checked ? target.checked : target.value;
		const name = target.name;
		setForm({
			...form,
			[name]: value,
		});
	}
	function handleSubmit(event) {
		event.preventDefault();
		console.log(form);
		sendCOVIDAnswer(form).then((res) => {
			console.log(res);
			if (res?.success) {
				setStatus({ isLoading: false, isSuccess: true });
			} else if (res?.error) {
				setStatus({ isLoading: false, isError: true });
			}
		});
		// alert(`Selected file - ${upload.current.files[0].name}`);
	}
	return (
		<Container className="form-container">
			<h2>Answer a COVID-19 Question </h2>
			<div style={{ display: "flex" }}>
				<Button
					tag={Link}
					to="/covid-19/faqs"
					style={{ marginLeft: "auto" }}
					size="sm"
					color="primary"
					outline
				>
					View Previous COVID-19 Questions
				</Button>
			</div>

			<Form onSubmit={handleSubmit} onChange={handleChange}>
				<FormGroup>
					<Label for="Name">Name</Label>
					<Input type="text" name="name" id="Name" />
				</FormGroup>
				<FormGroup>
					<Label for="email">Email</Label>
					<Input type="email" name="email" id="email" />
				</FormGroup>
				<FormGroup>
					<Label for="Name">COVID-19 Answer</Label>
					<Editor
						wrapperClassName="wrapper-class"
						editorClassName={clsx("form-control", "wysiwyg")}
						toolbarClassName="toolbar-class"
					/>
				</FormGroup>

				<Button color="primary">Submit COVID-19 Answer</Button>
			</Form>
		</Container>
	);
};

export default CovidAnswer;
